// import React, { createContext, useContext, useReducer, useCallback } from 'react';
// import axios from 'axios';

// // Initial form data - as a function that returns fresh object
// const getInitialFormData = () => ({
//   HeroImg: null,
//   HeroAltText: "",
//   Category: "",
//   Tags: "",
//   Title: "",
//   Subtitle: "",
//   Slug: "",
//   MetaTitle: "",
//   MetaDescription: "",
//   MetaKeywords: "",
//   Content: [
//     {
//       html: "",
//       img: null,
//       altText: "",
//     },
//   ],
//   FAQs: [{ Q: "", A: "" }],
//   status: "draft",
//   ScheduledDate: "",
// });

// // Initial state
// const initialState = {
//   formData: getInitialFormData(), // Function call for fresh data
//   errors: {},
//   loading: false,
//   popup: {
//     open: false,
//     type: "success",
//     message: "",
//   },
// };

// // Action types
// const SET_FORM_DATA = 'SET_FORM_DATA';
// const SET_ERRORS = 'SET_ERRORS';
// const SET_LOADING = 'SET_LOADING';
// const SET_POPUP = 'SET_POPUP';
// const RESET_FORM = 'RESET_FORM';

// // Reducer function
// const blogReducer = (state, action) => {
//   switch (action.type) {
//     case SET_FORM_DATA:
//       return {
//         ...state,
//         formData: action.payload,
//       };
//     case SET_ERRORS:
//       return {
//         ...state,
//         errors: action.payload,
//       };
//     case SET_LOADING:
//       return {
//         ...state,
//         loading: action.payload,
//       };
//     case SET_POPUP:
//       return {
//         ...state,
//         popup: action.payload,
//       };
//     case RESET_FORM:
//       return {
//         ...state,
//         formData: getInitialFormData(), // Fresh copy every time
//         errors: {},
//       };
//     default:
//       return state;
//   }
// };

// // Create context
// const BlogContext = createContext();

// // Provider component
// export const BlogPostProvider = ({ children }) => {
//   const [state, dispatch] = useReducer(blogReducer, initialState);

//   // Set form data
//   const setFormData = useCallback((data) => {
//     dispatch({ type: SET_FORM_DATA, payload: data });
//   }, []);

//   // Set errors
//   const setErrors = useCallback((errors) => {
//     dispatch({ type: SET_ERRORS, payload: errors });
//   }, []);

//   // Set loading state
//   const setLoading = useCallback((loading) => {
//     dispatch({ type: SET_LOADING, payload: loading });
//   }, []);

//   // Set popup
//   const setPopup = useCallback((popup) => {
//     dispatch({ type: SET_POPUP, payload: popup });
//   }, []);

//   // Reset form - Modified to ensure complete reset
//   const resetForm = useCallback(() => {
//     dispatch({ type: RESET_FORM });
//   }, []);

//   // Handle input changes
//   const handleInputChange = useCallback((e, index, field) => {
//     const { name, value } = e.target;
    
//     let updatedData;
    
//     if (field === "Content") {
//       const updated = [...state.formData.Content];
//       updated[index][name] = value;
//       updatedData = { ...state.formData, Content: updated };
//     } else if (field === "FAQs") {
//       const updated = [...state.formData.FAQs];
//       updated[index][name] = value;
//       updatedData = { ...state.formData, FAQs: updated };
//     } else {
//       updatedData = { ...state.formData, [name]: value };
//     }
    
//     setFormData(updatedData);
//   }, [state.formData, setFormData]);

//   // Handle image changes
//   const handleImageChange = useCallback((e, index, field) => {
//     const file = e.target.files[0];
    
//     let updatedData;
    
//     if (field === "HeroImg") {
//       updatedData = { ...state.formData, HeroImg: file };
//     } else if (field === "Content") {
//       const updated = [...state.formData.Content];
//       updated[index].img = file;
//       updatedData = { ...state.formData, Content: updated };
//     }
    
//     setFormData(updatedData);
//   }, [state.formData, setFormData]);

//   // Handle alt text changes
//   const handleAltTextChange = useCallback((e, index) => {
//     const value = e.target.value;
//     const updated = [...state.formData.Content];
//     updated[index].altText = value;
//     setFormData({ ...state.formData, Content: updated });
//   }, [state.formData, setFormData]);

//   // Add content block
//   const handleAddContent = useCallback(() => {
//     const updated = [...state.formData.Content, { html: "", img: null, altText: "" }];
//     setFormData({ ...state.formData, Content: updated });
//   }, [state.formData, setFormData]);

//   // Add FAQ block
//   const handleAddFAQ = useCallback(() => {
//     const updated = [...state.formData.FAQs, { Q: "", A: "" }];
//     setFormData({ ...state.formData, FAQs: updated });
//   }, [state.formData, setFormData]);

//   // Delete content block
//   const handleDeleteContent = useCallback((index) => {
//     const updated = [...state.formData.Content];
//     updated.splice(index, 1);
//     setFormData({ ...state.formData, Content: updated });
//   }, [state.formData, setFormData]);

//   // Delete FAQ block
//   const handleDeleteFAQ = useCallback((index) => {
//     const updated = [...state.formData.FAQs];
//     updated.splice(index, 1);
//     setFormData({ ...state.formData, FAQs: updated });
//   }, [state.formData, setFormData]);

//   // Handle editor changes
//   const handleEditorChange = useCallback((value, index) => {
//     const updated = [...state.formData.Content];
//     updated[index].html = value;
//     setFormData({ ...state.formData, Content: updated });
//   }, [state.formData, setFormData]);

//   // Form validation
//   const validateForm = useCallback((refs) => {
//     // Skip validation if status is draft
//     if (state.formData.status === "draft") {
//       return true;
//     }

//     const newErrors = {};

//     // Check HeroImg
//     if (!state.formData.HeroImg) newErrors.HeroImg = "Please upload hero image";
    
//     // Check HeroAltText - required if HeroImg is uploaded
//     if (state.formData.HeroImg && !state.formData.HeroAltText.trim())
//       newErrors.HeroAltText = "Please enter alt text for hero image";

//     // Required string fields
//     const requiredFields = [
//       "Category",
//       "Tags",
//       "Title",
//       "Subtitle",
//       "Slug",
//       "MetaTitle",
//       "MetaDescription",
//       "MetaKeywords",
//     ];

//     requiredFields.forEach((field) => {
//       if (!state.formData[field] || state.formData[field].trim() === "") {
//         newErrors[field] = `Please fill the ${field}`;
//       }
//     });

//     // Check scheduled date if status is schedule
//     if (state.formData.status === "schedule" && !state.formData.ScheduledDate) {
//       newErrors.ScheduledDate = "Please select a date for scheduling";
//     }

//     // Check content images for alt text
//     state.formData.Content.forEach((content, index) => {
//       if (content.img && !content.altText.trim()) {
//         newErrors[`ContentAltText_${index}`] = "Please enter alt text for content image";
//       }
//     });

//     setErrors(newErrors);

//     // Scroll to first error field
//     if (Object.keys(newErrors).length > 0 && refs) {
//       const firstErrorField = Object.keys(newErrors)[0];
//       if (refs[firstErrorField] && refs[firstErrorField].current) {
//         refs[firstErrorField].current.scrollIntoView({ 
//           behavior: "smooth", 
//           block: "center" 
//         });
//         refs[firstErrorField].current.focus?.();
//       }
//       return false;
//     }

//     return true;
//   }, [state.formData, setErrors]);

//   // Submit handler - Modified to reset form immediately on success
//   const handleSubmit = useCallback(async (refs) => {
//     if (!validateForm(refs)) return;

//     setLoading(true);

//     try {
//       const form = new FormData();

//       // Add basic form data
//       if (state.formData.HeroImg) form.append("HeroImg", state.formData.HeroImg);
//       form.append("HeroAltText", state.formData.HeroAltText);
//       form.append("Category", state.formData.Category);
//       form.append("Tags", state.formData.Tags);
//       form.append("Title", state.formData.Title);
//       form.append("Subtitle", state.formData.Subtitle);
//       form.append("Slug", state.formData.Slug);
//       form.append("status", state.formData.status);
      
//       // Add scheduled date if status is schedule
//       if (state.formData.status === "schedule") {
//         form.append("ScheduledDate", state.formData.ScheduledDate);
//       }
      
//       form.append("MetaTitle", state.formData.MetaTitle);
//       form.append("MetaDescription", state.formData.MetaDescription);
//       form.append("MetaKeywords", state.formData.MetaKeywords);

//       // Add content data
//       const contentToSend = state.formData.Content.map((c) => ({
//         content: c.html,
//         altText: c.altText,
//       }));
//       form.append("Content", JSON.stringify(contentToSend));

//       // Add content images
//       state.formData.Content.forEach((c, i) => {
//         if (c.img) form.append(`ContentImg_${i}`, c.img);
//       });

//       // Add FAQs
//       form.append("FAQs", JSON.stringify(state.formData.FAQs));

//       const { data } = await axios.post(
//         "https://dealacresnextbackend-1.onrender.com/newBlog/create",
//         form
//       );
          
//       if (data.success) {
//         let message = "";
//         if (state.formData.status === "published") {
//           message = "Blog Published Successfully!";
//         } else if (state.formData.status === "schedule") {
//           message = "Blog Scheduled Successfully!";
//         } else {
//           message = "Blog Saved as Draft!";
//         }
        
//         // Reset form immediately on success
//         resetForm();
        
//         // Show popup after form reset
//         setPopup({
//           open: true,
//           type: "success",
//           message: message,
//         });
//       } else {
//         setPopup({
//           open: true,
//           type: "error",
//           message: data.message || "Something went wrong!",
//         });
//       }
//     } catch (err) {
//       setPopup({ 
//         open: true, 
//         type: "error", 
//         message: err?.response?.data?.message || "Something went wrong!" 
//       });
//     } finally {
//       setLoading(false);
//     }
//   }, [state.formData, validateForm, setLoading, setPopup, resetForm]);

//   // Value object to be provided to consumers
//   const value = {
//     formData: state.formData,
//     errors: state.errors,
//     loading: state.loading,
//     popup: state.popup,
//     setFormData,
//     setErrors,
//     setLoading,
//     setPopup,
//     resetForm,
//     handleInputChange,
//     handleImageChange,
//     handleAltTextChange,
//     handleAddContent,
//     handleAddFAQ,
//     handleDeleteContent,
//     handleDeleteFAQ,
//     handleEditorChange,
//     validateForm,
//     handleSubmit,
//   };

//   return <BlogContext.Provider value={value}>{children}</BlogContext.Provider>;
// };

// // Custom hook to use blog context
// export const useBlogPost = () => {
//   const context = useContext(BlogContext);
//   if (!context) {
//     throw new Error('useBlog must be used within a BlogProvider');
//   }
//   return context;
// };

// export default BlogContext;


import React, { createContext, useContext, useReducer } from 'react';
import axios from 'axios';

// Initial form data
const getInitialFormData = () => ({
  HeroImg: null,
  HeroAltText: "",
  Category: "",
  SubCategory: "",
  Title: "",
  Subtitle: "",
   Tags: "",
  Slug: "",
  MetaTitle: "",
  MetaDescription: "",
  MetaKeywords: "",
  Content: [
    {
      html: "",
      img: null,
      altText: "",
    },
  ],
  FAQs: [{ Q: "", A: "" }],
  status: "draft",
  ScheduledDate: "",
});

// Initial state
const initialState = {
  formData: getInitialFormData(),
  errors: {},
  loading: false,
  popup: {
    open: false,
    type: "success",
    message: "",
  },
};

// Action types
const SET_FORM_DATA = 'SET_FORM_DATA';
const SET_ERRORS = 'SET_ERRORS';
const SET_LOADING = 'SET_LOADING';
const SET_POPUP = 'SET_POPUP';

// Reducer function
const blogReducer = (state, action) => {
  switch (action.type) {
    case SET_FORM_DATA:
      return {
        ...state,
        formData: action.payload,
      };
    case SET_ERRORS:
      return {
        ...state,
        errors: action.payload,
      };
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case SET_POPUP:
      return {
        ...state,
        popup: action.payload,
      };
    default:
      return state;
  }
};

// Create context
const BlogContext = createContext();

// Provider component
export const BlogPostProvider = ({ children }) => {
  const [state, dispatch] = useReducer(blogReducer, initialState);

  // Set form data
  const setFormData = (data) => {
    dispatch({ type: SET_FORM_DATA, payload: data });
  };

  // Set errors
  const setErrors = (errors) => {
    dispatch({ type: SET_ERRORS, payload: errors });
  };

  // Set loading state
  const setLoading = (loading) => {
    dispatch({ type: SET_LOADING, payload: loading });
  };

  // Set popup
  const setPopup = (popup) => {
    dispatch({ type: SET_POPUP, payload: popup });
  };

  // Handle input changes
  const handleInputChange = (e, index, field) => {
    const { name, value } = e.target;
    
    let updatedData;
    
    if (field === "Content") {
      const updated = [...state.formData.Content];
      updated[index][name] = value;
      updatedData = { ...state.formData, Content: updated };
    } else if (field === "FAQs") {
      const updated = [...state.formData.FAQs];
      updated[index][name] = value;
      updatedData = { ...state.formData, FAQs: updated };
    } else {
      updatedData = { ...state.formData, [name]: value };
    }
    
    setFormData(updatedData);
  };

  // Handle image changes
  const handleImageChange = (e, index, field) => {
    const file = e.target.files[0];
    
    let updatedData;
    
    if (field === "HeroImg") {
      updatedData = { ...state.formData, HeroImg: file };
    } else if (field === "Content") {
      const updated = [...state.formData.Content];
      updated[index].img = file;
      updatedData = { ...state.formData, Content: updated };
    }
    
    setFormData(updatedData);
  };

  // Handle alt text changes
  const handleAltTextChange = (e, index) => {
    const value = e.target.value;
    const updated = [...state.formData.Content];
    updated[index].altText = value;
    setFormData({ ...state.formData, Content: updated });
  };

  // Add content block
  const handleAddContent = () => {
    const updated = [...state.formData.Content, { html: "", img: null, altText: "" }];
    setFormData({ ...state.formData, Content: updated });
  };

  // Add FAQ block
  const handleAddFAQ = () => {
    const updated = [...state.formData.FAQs, { Q: "", A: "" }];
    setFormData({ ...state.formData, FAQs: updated });
  };

  // Delete content block
  const handleDeleteContent = (index) => {
    const updated = [...state.formData.Content];
    updated.splice(index, 1);
    setFormData({ ...state.formData, Content: updated });
  };

  // Delete FAQ block
  const handleDeleteFAQ = (index) => {
    const updated = [...state.formData.FAQs];
    updated.splice(index, 1);
    setFormData({ ...state.formData, FAQs: updated });
  };

  // Handle editor changes
  const handleEditorChange = (value, index) => {
    const updated = [...state.formData.Content];
    updated[index].html = value;
    setFormData({ ...state.formData, Content: updated });
  };

  // Form validation
  const validateForm = (refs) => {
    // Skip validation if status is draft
    if (state.formData.status === "draft") {
      return true;
    }

    const newErrors = {};

    // Check HeroImg
    if (!state.formData.HeroImg) newErrors.HeroImg = "Please upload hero image";
    
    // Check HeroAltText - required if HeroImg is uploaded
    if (state.formData.HeroImg && !state.formData.HeroAltText.trim())
      newErrors.HeroAltText = "Please enter alt text for hero image";

    // Required string fields
    const requiredFields = [
      "Category",
      "SubCategory",
      "Title",
      "Subtitle",
        "Tags",
      "Slug",
      "MetaTitle",
      "MetaDescription",
      "MetaKeywords",
    ];

    requiredFields.forEach((field) => {
      if (!state.formData[field] || state.formData[field].trim() === "") {
        newErrors[field] = `Please fill the ${field}`;
      }
    });

    // Check scheduled date if status is schedule
    if (state.formData.status === "scheduled" && !state.formData.ScheduledDate) {
      newErrors.ScheduledDate = "Please select a date for scheduling";
    }

    // Check content images for alt text
    state.formData.Content.forEach((content, index) => {
      if (content.img && !content.altText.trim()) {
        newErrors[`ContentAltText_${index}`] = "Please enter alt text for content image";
      }
    });

    setErrors(newErrors);

    // Scroll to first error field
    if (Object.keys(newErrors).length > 0 && refs) {
      const firstErrorField = Object.keys(newErrors)[0];
      if (refs[firstErrorField] && refs[firstErrorField].current) {
        refs[firstErrorField].current.scrollIntoView({ 
          behavior: "smooth", 
          block: "center" 
        });
        refs[firstErrorField].current.focus?.();
      }
      return false;
    }

    return true;
  };

  // Submit handler - No form reset after submission
  const handleSubmit = async (refs) => {
    // Always validate the form
    const isValid = validateForm(refs);
    
    // If not valid, show errors and return
    if (!isValid) return;

    setLoading(true);

    try {
      const form = new FormData();

      // Add basic form data
      if (state.formData.HeroImg) form.append("HeroImg", state.formData.HeroImg);
      form.append("HeroAltText", state.formData.HeroAltText);
      form.append("Category", state.formData.Category);
      form.append("SubCategory", state.formData.SubCategory);
      form.append("Tags", state.formData.Tags);
      form.append("Title", state.formData.Title);
      form.append("Subtitle", state.formData.Subtitle);
      form.append("Slug", state.formData.Slug);
      form.append("status", state.formData.status);
      
      // Add scheduled date if status is schedule
      if (state.formData.status === "scheduled") {
        form.append("ScheduledDate", state.formData.ScheduledDate);
      }
      
      form.append("MetaTitle", state.formData.MetaTitle);
      form.append("MetaDescription", state.formData.MetaDescription);
      form.append("MetaKeywords", state.formData.MetaKeywords);

      // Add content data
      const contentToSend = state.formData.Content.map((c) => ({
        content: c.html,
        altText: c.altText,
      }));
      form.append("Content", JSON.stringify(contentToSend));

      // Add content images
      state.formData.Content.forEach((c, i) => {
        if (c.img) form.append(`ContentImg_${i}`, c.img);
      });

      // Add FAQs
      const filteredFAQs = state.formData.FAQs.filter(
        (faq) => faq.Q.trim() !== "" && faq.A.trim() !== ""
         );

      form.append("FAQs", JSON.stringify(filteredFAQs));

      const { data } = await axios.post(
        "https://parcharmanch-backend-7kc7.onrender.com/parcharmanch/createBlogPost",
        form
      );
          
     if (data.success) {
  let message = "";
  if (state.formData.status === "published") {
    message = "Blog Published Successfully!";
  } else if (state.formData.status === "scheduled") {
    message = "Blog Scheduled Successfully!";
  } else {
    message = "Blog Saved as Draft!";
  }

  // ✅ RESET FORM DATA
  setFormData(getInitialFormData());
  setErrors({});

  setPopup({
    open: true,
    type: "success",
    message: message,
  });
} else {
        setPopup({
          open: true,
          type: "error",
          message: data.message || "Something went wrong!",
        });
      }
    } catch (err) {
      setPopup({ 
        open: true, 
        type: "error", 
        message: err?.response?.data?.message || "Something went wrong!" 
      });
    } finally {
      setLoading(false);
    }
  };

  // Value object to be provided to consumers
  const value = {
    formData: state.formData,
    errors: state.errors,
    loading: state.loading,
    popup: state.popup,
    setFormData,
    setErrors,
    setLoading,
    setPopup,
    handleInputChange,
    handleImageChange,
    handleAltTextChange,
    handleAddContent,
    handleAddFAQ,
    handleDeleteContent,
    handleDeleteFAQ,
    handleEditorChange,
    validateForm,
    handleSubmit,
  };

  return <BlogContext.Provider value={value}>{children}</BlogContext.Provider>;
};

// Custom hook to use blog context
export const useBlogPost = () => {
  const context = useContext(BlogContext);
  if (!context) {
    throw new Error('useBlog must be used within a BlogProvider');
  }
  return context;
};

export default BlogContext;
